import { QueryFactory } from "../../../../Common";
import { BS } from "../../../../Contracts";
export const QCalculateYourbetBets = QueryFactory(BS.QueryTypes.CalculateYourbetBets);
//# sourceMappingURL=QCalculateYourbetBets.js.map